export enum ModalDimension {
    SMALL = 'modal-sm',
    MEDIUM = 'modal-lg',
    LARGE = 'modal-xl'
}